import React from "react";
import { TableInput } from "components/common/input";
import type { IMemberDetail } from "service/interface/member";
import moment from "moment";

interface Props {
  data: IMemberDetail;
  setData: React.Dispatch<React.SetStateAction<IMemberDetail>>;
}

export function AccountInfoTable({ data, setData }: Props) {
  const handlePhoneNumbInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      phoneNumber: e.target.value.replace(/[^0-9]/g, ""),
    }));
  };

  const handleEmailInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      email: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          계정 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이름
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput value={data.name} onChange={() => {}} readOnly />
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            생성일
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            <TableInput
              value={moment(data.createdAt).format("YYYY-MM-DD")}
              onChange={() => {}}
              readOnly
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            휴대폰 번호
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.phoneNumber}
              onChange={handlePhoneNumbInput}
              placeholder="휴대폰 번호를 입력해 주세요"
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이메일
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.email}
              onChange={handleEmailInput}
              placeholder="이메일을 입력해 주세요"
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            마케팅 수신 동의
          </div>
          <div className="flex h-full w-[787px] items-center gap-[32px] px-[24px] text-M3 text-gray-5">
            <div className="flex items-center gap-[6px]">
              <input
                type="radio"
                checked={data.emailMarketing}
                className="text-blue-1 focus:ring-0 focus:ring-white"
              />
              <p className="m-0 text-M3">이메일</p>
            </div>
            <div className="flex items-center gap-[6px]">
              <input
                type="radio"
                checked={data.kakaoMarketing}
                className="text-blue-1 focus:ring-0 focus:ring-white"
              />
              <p className="m-0 text-M3">카카오톡</p>
            </div>
            <div className="flex items-center gap-[6px]">
              <input
                type="radio"
                checked={data.smsMarketing}
                className="text-blue-1 focus:ring-0 focus:ring-white"
              />
              <p className="m-0 text-M3">SMS</p>
            </div>
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            추천인 코드
          </div>
          <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
            {data.referralCode}
          </div>
        </div>
      </div>
    </div>
  );
}
